import React from 'react'
import { t } from '../../i18n/i18n'
import { Field, Input } from '@fluentui/react-components'
import { Control, Controller } from 'react-hook-form'

type ControlledOrganisationNumberInputProps = {
   name: any
   control: Control<any>
   existingOrganisationNumbers: string[]
   label?: string
   disabled?: boolean
   required?: boolean
}
export const ControlledOrganisationNumberInput = ({
   name,
   control,
   existingOrganisationNumbers,
   label,
   disabled,
   required,
}: ControlledOrganisationNumberInputProps) => {
   const formatOrgNumber = (value: string) => {
      const cleanedValue = value.replace(/\D/g, '')
      if (cleanedValue.length <= 6) {
         return cleanedValue
      }
      return `${cleanedValue.slice(0, 6)}-${cleanedValue.slice(6, 10)}`
   }
   return (
      <Controller
         name={name}
         control={control}
         rules={{
            required: required ? t('RequiredField') : false,
            pattern: /^[0-9]+$/,
            minLength: { value: 10, message: t('OrganisationNumberMustBe10Digits') },
            maxLength: { value: 10, message: t('OrganisationNumberMustBe10Digits') },
            validate: (value) => {
               const isUnique = existingOrganisationNumbers.every((orgNumber) => orgNumber !== value)
               return isUnique || t('OrganisationNumberAlreadyRegistered')
            },
         }}
         render={({ field: { value, onChange }, fieldState: { error, invalid } }) => {
            return (
               <Field
                  label={label}
                  required={required ?? false}
                  validationMessage={error ? error.message : null}
                  validationState={error || invalid ? 'error' : null}
               >
                  <Input
                     type="text"
                     value={value ? formatOrgNumber(value.toString()) : ''}
                     onChange={(e, data) => {
                        const rawValue = data.value.replace(/\D/g, '').slice(0, 10)
                        onChange(rawValue)
                     }}
                     disabled={disabled ?? false}
                  />
               </Field>
            )
         }}
      />
   )
}
